import React, { ReactNode } from 'react'
import MyImage from '@/shared/components/myImage'
import { S3_PREFIX } from '@/shared/constants'
import FlagTeam from '@/assets/images/placeholder/team.png'
import { BLUR_DATA_URL_BASE64 } from '@/shared/constants'
import momTrophy from '@/assets/images/placeholder/momtrophy.svg'
import batIcon from '@/assets/images/icon/batIcon.svg'
import PlayerPlaceholder from '@/assets/images/placeholder/player.svg'
import getStatus from '@/shared/hooks/useStatus'
import { convertDate, dateCheck, getSlugUrl, replaceStringToShort } from '@/shared/utils'
import CustomLink from '@/shared/components/customLink'
import Card from '../../card'
import LinkWrapper from '../../linkWrapper'
// import Ads from '../../ads'

const scoreSplit = (score: any) => {
  if (score?.includes('&')) {
    let newScoreString = ''
    score.split('&').forEach((ele: any, i: number) => {
      if (i === 0 && ele) {
        const [score] = ele.split(' (')
        newScoreString += score + ' &'
      } else if (ele) {
        newScoreString += ele
      }
    })
    score = newScoreString
  }
  const scoreSplittedData = score?.split(' ')
  if (scoreSplittedData?.length > 0) {
    return (
      <span>
        {scoreSplittedData?.map((ele: string, i: number) => {
          if (ele.match(/\(|\)/) || ele.includes('&')) {
            return (
              <span key={ele + i} className='font-normal'>
                {ele + ' '}
              </span>
            )
          } else {
            return <b key={ele + i}>{ele + ' '}</b>
          }
        })}
      </span>
    )
  }
}

export default function Header({ data, slug }: any) {

  const { sStatus, sStatusStr, sLiveGameStatus } = getStatus(data)
  function getTeamData(key: string): ReactNode {
    return (
      <div className={`font-extrabold flex items-center`}>
        <div className='align-middle mr-2'>
          <MyImage
            src={data?.[key]?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${data?.[key]?.oTeam?.oImg?.sUrl}` : FlagTeam}
            className='aspect-square rounded-full'
            alt={data?.[key]?.oTeam?.sAbbr}
            width={36}
            height={36}
            sizes='(max-width: 767px) 24px, (max-width: 991px) 24px, (max-width: 1190px) 200px, 24px'
          />
        </div>
        {sStatusStr !== 'scheduled' && sStatusStr !== 'cancelled' ? (
          <div className={`flex relative ml-1 align-middle`}>
            <CustomLink href={`/${data?.[key]?.oTeam?.oSeo?.sSlug}`}>
            <div className='text-sm leading-5 sm:text-lg font-medium'>
              {data?.[key]?.oTeam?.[sStatusStr === 'live' ? 'sAbbr' : 'sTitle']}
            </div>
            </CustomLink>
            {sStatusStr === 'live' && data?.[key]?.sScoresFull?.includes('*') && (
              <div className='ml-1 w-4 flex items-center'>
                <MyImage src={batIcon} alt='*' width={16} height={16} />
              </div>
            )}
          </div>
        ) : (
          <>
           <CustomLink href={`/${data?.[key]?.oTeam?.oSeo?.sSlug}`}>
            <span className='ml-1 text-sm leading-5 sm:text-lg font-medium'>{data?.[key]?.oTeam?.sTitle || data?.[key]?.oTeam?.sAbbr}</span>
            </CustomLink>
          </>
        )}
      </div>
    )
  }

  function getTeamScore(key: string): ReactNode {
    return (
      <p className='text-sm sm:text-base font-bold'>
        {data?.nLatestInningNumber === 1 &&
          (data?.[key]?.sScoresFull ? (
            <span className='whitespace-nowrap'>{scoreSplit(data?.[key]?.sScoresFull)}</span>
          ) : (
            <span className='text-t-light'>Yet To Bat</span>
          ))}
        {data?.nLatestInningNumber > 1 &&
          (data?.[key]?.sScoresFull?.includes('*') ? (
            <span className='whitespace-nowrap'>{scoreSplit(data?.[key]?.sScoresFull)}</span>
          ) : (
            <span
              className={
                sStatusStr === 'completed' && data?.[key]?.oTeam?._id === data?.oWinner?._id
                  ? 'text-textOffWhite whitespace-nowrap'
                  : 'text-TextScoredCompplete whitespace-nowrap'
              }
            >
              {data?.[key]?.sScoresFull ? scoreSplit(data?.[key]?.sScoresFull) : <span className='text-t-light'>Yet To Bat</span>}
            </span>
          ))}
      </p>
    )
  }

  const statusColor: Record<string, string> = {
    live: 'text-danger',
    scheduled: 'text-ScheduledBG',
    completed: 'text-[#00A632]',
    cancelled: 'text-danger'
  }

  const isBallByBall = sStatusStr === 'live' && data?.sBallEvent && data?.sBallEvent !== '' && data?.sBallEvent !== null

  return (
    <>
      <div className='grid grid-cols-12 gap-2'>
        <div className={`w-full col-span-12  ${(sStatusStr === 'scheduled')? 'md:col-span-12' : 'md:col-span-8'}`}>
          <div className={`text-t-origin md:flex items-center justify-between mb-3 md:mb-4`}>
            <div className='w-full'>
              <h1 className='font-bold text-base md:text-[22px] md:font-extrabold mb-1 md:leading-6 text-textOffWhite'>
                {data?.sTitle}
                {data?.sSubtitle && ', ' + data?.sSubtitle}
                {sStatusStr === 'live' ? ', Live Cricket Score' : ', Cricket Score'}
                {slug?.length ? <span className='capitalize'>{slug[1] ? `, ${slug[1]?.replace('-', ' ')}` : ''}</span> : null}
              </h1>
              <p className='mb-0 flex  text-t-secondary lg:items-center flex-col text-xs font-normal md:text-base flex-wrap lg:flex-row'>
                <span>
                  {data?.oSeries?.oCategory?.oSeo?.sSlug || data?.oSeries?.oSeo?.sSlug ? (
                    <CustomLink
                      href={getSlugUrl(`/${data?.oSeries?.oCategory?.oSeo?.sSlug || data?.oSeries?.oSeo?.sSlug}`)}
                      className='text-t-secondary hover:text-primary-500 transition-colors'
                      prefetch={false}
                    >
                      {data?.oSeries?.sTitle}
                      {data?.oSeries?.sSeason && ', ' + data?.oSeries?.sSeason}
                    </CustomLink>
                  ) : (
                    <>
                      {data?.oSeries?.sTitle}
                      {data?.oSeries?.sSeason && ', ' + data?.oSeries?.sSeason}
                    </>
                  )}
                </span>
                {data?.dStartDate && <span className='hidden lg:block h-1.5 w-1.5 bg-t-secondary rounded-full mx-2'></span>}
                <span className='items-start md:items-center flex md:flex-row flex-col'>
                  <span>{convertDate(dateCheck(data?.dStartDate))}</span>
                  {/* {data?.oVenue?.sName && (
                    <span className='hidden md:inline-block h-1.5 w-1.5 bg-t-secondary rounded-full mt-1.5 sm:mt-0 mx-2'></span>
                  )} */}
                  {/* <span>{data?.oVenue?.sName}</span> */}
                </span>
              </p>
            </div>
          </div>
          {/* matchCard */}
          <Card
            className={`flex-col !bg-transparent h-full border-none !p-0 grid grid-cols-12 gap-x-6 gap-y-2 mt-2 w-full ${
              isBallByBall ? 'lg:pr-0' : ''
            }`}
          >
            <div className={`col-span-12 lg:col-span-12`}>
              <div className='flex justify-between items-center mb-4 mt-1 gap-2'>
                <div className='w-full'>
                  <p className='flex items-center mb-2 text-ellipsis whitespace-nowrap overflow-x-auto'>
                    <span className={`font-medium flex text-sm items-center ${statusColor[sStatusStr]}`}>
                      {sStatusStr === 'live' ? (
                        <>
                          <span className='h-2.5 w-2.5 rounded-full bg-danger mr-1' />
                          {sLiveGameStatus}
                        </>
                      ) : (
                        sStatus
                      )}
                    </span>
                    <span className='font-medium text-sm text-t-light ml-4'>{data?.oVenue?.sLocation && data?.oVenue?.sLocation} </span>
                    <span className='h-1.5 w-1.5 rounded-full bg-gray-500 mx-2'></span>
                    <span className='font-medium text-sm text-t-light '>{data?.sSubtitle && data?.sSubtitle} </span>
                    {data?.oFormat?.sText && (
                      <>
                        <span className='h-1.5 w-1.5 rounded-full bg-gray-500 mx-2'></span>
                        <span className='font-medium text-sm text-t-light '>{data?.oFormat?.sText} </span>
                      </>
                    )}
                  </p>

                  <div className='w-full flex items-center mt-2'>
                    <div className='w-[70%] md:w-full'>
                      <div className='flex w-full items-center justify-between mb-3 relative'>
                        {/* Team A */}
                        {data?.iBattingTeamId === data?.oTeamScoreB?.iTeamId && sStatusStr === 'live'
                          ? getTeamData('oTeamScoreB')
                          : getTeamData('oTeamScoreA')}
                        {data?.iBattingTeamId === data?.oTeamScoreB?.iTeamId && sStatusStr === 'live'
                          ? getTeamScore('oTeamScoreB')
                          : getTeamScore('oTeamScoreA')}
                      </div>
                      <div className='flex items-center justify-between mb-3 relative'>
                        {/* Team B */}
                        {data?.iBattingTeamId === data?.oTeamScoreB?.iTeamId && sStatusStr === 'live'
                          ? getTeamData('oTeamScoreA')
                          : getTeamData('oTeamScoreB')}
                        {data?.iBattingTeamId === data?.oTeamScoreB?.iTeamId && sStatusStr === 'live'
                          ? getTeamScore('oTeamScoreA')
                          : getTeamScore('oTeamScoreB')}
                      </div>
                    </div>
                    <div className='md:hidden w-[30%]'>
                      {isBallByBall && (
                        <div className='col-span-4 border-l border-borderStroke ml-4 p-5 flex items-center justify-center'>
                          <p className='text-base text-center text-primary-500 font-bold'>
                            {data?.sBallEvent.length > 45 ? (
                              <span className='sm:inline'>{data?.sBallEvent.substring(0, 45) + '...'}</span>
                            ) : data?.sBallEvent.length > 25 ? (
                              <span className='sm:hidden inline'>{data?.sBallEvent.substring(0, 25) + '...'}</span>
                            ) : (
                              data?.sBallEvent
                            )}
                          </p>
                        </div>
                      )}
                      {sStatusStr === 'completed' && data?.oMom ? (
                        <div className='col-span-4 border-l border-borderStroke ml-8 p-5  md:flex hidden items-center justify-center'>
                          <div className=' flex flex-col xl:flex-row items-center gap-4 xxl:gap-12 px-4 py-2 rounded-2xl border border-c'>
                            <MyImage
                              src={data?.oMom?.oImg?.sUrl ? `${S3_PREFIX}${data?.oMom?.oImg?.sUrl}` : PlayerPlaceholder}
                              alt={data?.oMom?.sFullName || 'Player'}
                              className='aspect-square rounded-full flex-shrink-0 w-20 h-20'
                              blurDataURL={BLUR_DATA_URL_BASE64}
                              placeholder='blur'
                              width={80}
                              height={80}
                            />
                            <div className='flex flex-col items-center'>
                              <MyImage src={momTrophy} blurDataURL={BLUR_DATA_URL_BASE64} placeholder='blur' width={72} height={72} />
                              <span className='w-20 sm:w-32 block text-t-info leading-5 text-center'>Man of the Match</span>
                              <span className='mb-0 line-clamp-1 leading-5 sm:text-xl text-center font-bold overflow-auto text-ellipsis'>
                                {data?.oMom?.sFullName || ''}
                              </span>
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>

              <div className='flex border-b border-b-c-light border-fg mb-2'></div>
              <div className='flex flex-col md:flex-row md:items-center justify-between font-normal'>
                <p
                  className={`text-ellipsis text-sm md:text-base font-medium ${
                    sStatusStr === 'live' || sStatusStr === 'cancelled'
                      ? 'text-textDselected'
                      : sStatusStr !== 'completed'
                      ? 'text-textDselected'
                      : '!text-[#00A632]'
                  }  overflow-hidden`}
                >
                  {sStatusStr === 'scheduled' && convertDate(dateCheck(data?.dStartDate))}
                  {sStatusStr === 'live' &&
                    (replaceStringToShort(data?.oTeamScoreA?.oTeam, data?.oTeamScoreB?.oTeam, data?.sStatusNote) ||
                      'Match Will Start Soon')}
                  {sStatusStr === 'completed' &&
                    replaceStringToShort(data?.oTeamScoreA?.oTeam, data?.oTeamScoreB?.oTeam, data?.sStatusNote)}
                  {sStatusStr === 'cancelled' &&
                    (replaceStringToShort(data?.oTeamScoreA?.oTeam, data?.oTeamScoreB?.oTeam, data?.sStatusNote) ||
                      'Match Will Start Soon')}
                </p>
                {sStatusStr === 'live' ? (
                  <div className='flex gap-2 items-center'>
                    <p className='text-sm md::text-base font-medium inline text-t-light'>
                      {data?.oLiveScore?.nRunrate > 0 ? `CRR: ${data?.oLiveScore?.nRunrate}` : ''}
                      {data?.oLiveScore?.nRunrate > 0 && data?.oLiveScore?.sRequiredRunrate > 0 ? ' | ' : ''}
                      {data?.oLiveScore?.sRequiredRunrate > 0 ? `RRR: ${data?.oLiveScore?.sRequiredRunrate}` : ''}
                    </p>
                    {data?.aInning?.find((a: any) => a?.nInningNumber === 1)?.oBattingTeam?.sTitle === data?.oLiveScore?.oTeam?.sTitle &&
                      data?.sProjectScore && (
                        <div className='flex text-t-light text-base font-bold gap-2'>
                          <div className='h-5 w-[2px] bg-t-light' />
                          <p>Projected Score: {data?.sProjectScore}</p>
                        </div>
                      )}
                  </div>
                ) : null}
              </div>
            </div>
          </Card>
          {(data?.oStatus?.sValue === 'live' || data?.oStatus?.sValue === 'scheduled') && (
            <div className='scroll-list mt-2 gap-6 items-center'>
              {data?.oCricTezzPrediction?.sessionPredict &&
              (data?.oCricTezzPrediction?.sessionPredict?.sS_min > 0 || data?.oCricTezzPrediction?.sessionPredict?.sS_max > 0) ? (
                <Card className='px-6 py'>
                  <div className='text-white text-xs font-medium self-center pe-3 whitespace-nowrap'>
                    {data?.oCricTezzPrediction?.sessionPredict?.sS_over
                      ? `${data?.oCricTezzPrediction?.sessionPredict?.sS_over} Overs:`
                      : ''}
                  </div>
                  {data?.oCricTezzPrediction?.sessionPredict?.sS_min ? (
                    <div className='text-white text-xs font-bold self-stretch bg-reject px-2.5 py-2 rounded-lg me-2'>
                      {data?.oCricTezzPrediction?.sessionPredict?.sS_min}
                    </div>
                  ) : null}
                  {data?.oCricTezzPrediction?.sessionPredict?.sS_max ? (
                    <div className='text-white text-xs font-bold self-stretch bg-confirm px-2.5 py-2 rounded-lg'>
                      {data?.oCricTezzPrediction?.sessionPredict?.sS_max}
                    </div>
                  ) : null}
                </Card>
              ) : null}
            </div>
          )}
        </div>
        {isBallByBall && (
          <div className='col-span-4 border-l border-borderStroke ml-8 p-5 hidden sm:flex items-center justify-center'>
            <p className='text-4xl text-[#647333] font-bold'>
              {data?.sBallEvent.length > 45 ? (
                <span className='sm:inline'>{data?.sBallEvent.substring(0, 45) + '...'}</span>
              ) : data?.sBallEvent.length > 25 ? (
                <span className='sm:hidden inline'>{data?.sBallEvent.substring(0, 25) + '...'}</span>
              ) : (
                data?.sBallEvent
              )}
            </p>
          </div>
        )}

        {sStatusStr === 'completed' && data?.oMom ? (
          <div className='col-span-4 border-l border-borderStroke ml-8 p-5  md:flex hidden items-center justify-center'>
            <div className='flex flex-col xl:flex-row items-center gap-4 xxl:gap-14 px-4 py-2 rounded-2xl border-2  border-borderStroke'>
              <MyImage
                src={data?.oMom?.oImg?.sUrl ? `${S3_PREFIX}${data?.oMom?.oImg?.sUrl}` : PlayerPlaceholder}
                alt={data?.oMom?.sFullName || 'Player'}
                className='aspect-square rounded-full flex-shrink-0 w-[76px] h-[76px]'
                blurDataURL={BLUR_DATA_URL_BASE64}
                placeholder='blur'
                width={76}
                height={76}
              />
              <div className='flex flex-col items-center'>
                <MyImage src={momTrophy} blurDataURL={BLUR_DATA_URL_BASE64} placeholder='blur' width={72} height={72} />
                <span className='w-20 sm:w-32 block text-sm text-t-origin font-normal text-center'>Player of the Match</span>
                <LinkWrapper link={`/${data?.oMom?.oSeo?.sSlug}`}>
                <span className='mb-0 line-clamp-1 hover:text-primary-500 sm:text-base text-center text-t-origin font-bold overflow-auto text-ellipsis'>
                  {data?.oMom?.sFullName || ''}
                </span>
                </LinkWrapper>
              </div>
            </div>
          </div>
        ) : null}

        {/* {sStatusStr === 'scheduled' && (
          <div className='col-span-4 border-l border-borderStroke ml-8 p-5  md:flex flex-col hidden items-center justify-center text-center'>
            <p className='mb-0 text-2xl font-bold text-wrap text-matchText'>{convertDate(dateCheck(data?.dStartDate))}</p>
          </div>
        )} */}
      </div>
    </>
  )
}
